import { ZapierSession } from '@zapier/universal-layout';

import type { Fetch } from '../../shared/types';
import { Zap } from '../../zapier/types';
import {
  Schedule,
  Filter,
  hodToIndex,
  dowToIndex,
  domToIndex,
} from '@zapier/transfer';

type OptionalCronNumber = number | string | undefined;

type RequestData = {
  accountId: ZapierSession['currentAccountId'];
  zapId: Zap['id'];
  scheduleId?: string;
  frequency: Schedule.Frequency;
  scheduleParams: Schedule.Params;
  filterParams: Filter.Criteria[];
  timezone: string;
};

type SharedRequestBody = {
  frequency: Schedule.Frequency;
  timezone: string;
  filters: Filter.Criteria[];
  hour_of_day: OptionalCronNumber;
  day_of_week: OptionalCronNumber;
  day_of_month: OptionalCronNumber;
};

const buildHeaders = ({ accountId }: RequestData) => ({
  'x-account-id': String(accountId),
});

const buildBody = ({
  filterParams,
  timezone,
  frequency,
  scheduleParams: { hod, dom, dow },
}: RequestData): SharedRequestBody => ({
  filters: filterParams,
  timezone,
  frequency,
  hour_of_day: hodToIndex(hod),
  day_of_week: dowToIndex(dow),
  day_of_month: domToIndex(dom as any), // TODO: fix Schedule.Params type in @zapier/transfer
});

const createSchedule = (fetch: Fetch, data: RequestData) =>
  fetch('v1/scheduled-transfers/', {
    headers: buildHeaders(data),
    method: 'POST',
    body: {
      account_id: data.accountId,
      zap_id: data.zapId,
      ...buildBody(data),
    },
  });

const updateSchedule = (fetch: Fetch, data: RequestData) =>
  fetch(`v1/scheduled-transfers/${data.zapId}/`, {
    headers: buildHeaders(data),
    method: 'PUT',
    body: buildBody(data),
  });

const createOrUpdateSchedule = (fetch: Fetch, data: RequestData) =>
  (data.scheduleId ? updateSchedule : createSchedule)(fetch, data);

export default createOrUpdateSchedule;
